import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientWithCounts, IClientQueryParams } from "models/client";

export interface ClientSliceState {
    clients: ClientWithCounts[]
    clientCount: number
    query: IClientQueryParams
}

export const initialState: ClientSliceState = {
    clients: [],
    clientCount: 0,
    query: {
        page: 0,
        limit: Number.MAX_SAFE_INTEGER,
    },
}

const ClientSlice = createSlice({
    name: 'client-slice',
    initialState,
    reducers: {
        setClients(state, { payload }: PayloadAction<ClientWithCounts[]>) {
            state.clients = payload
        },
        setClientCount(state, { payload }: PayloadAction<number>) {
            state.clientCount = payload
        },
        setQuery(state, { payload }: PayloadAction<IClientQueryParams>) {
            state.query = payload
        },
    }
})

export const {
    setClients,
    setClientCount,
    setQuery,
} = ClientSlice.actions

export default ClientSlice.reducer
